import { el, list } from 'redom';
import Sortable from 'sortablejs';

import './index.scss';

class ColumnsOrderPanel {

  constructor(configuration) {
    this.menu = configuration.menu;
    this.node = configuration.node;
    this.onChange = configuration.onChange;
    this.listContainer = null;
    this.initUI();
    this.renderList();
  }

  initUI() {
    this.el = el('.columns-order-input-panel-main', [
      el('label.side-value-control-label.field-label', 'Mobile view order'),
      this.listContainer = el('.columns-order-input-controls')
    ]);
  }

  renderList() {
    const items = this.node.children.map((child, index) => {
      const position = child.properties && child.properties.position !== undefined ? child.properties.position : index;
      return { id: index, content: `Column ${index}`, position: position };
    }).sort(function(a, b) {
      return a.position - b.position;
    });

    this.list = list(this.listContainer, ListItem, 'id');
    this.list.update(items);

    new Sortable(this.listContainer, {
      onEnd: this.handleSortEnd.bind(this)
    });

  }

  handleSortEnd() {
    var children = this.listContainer.children;
    var items = [];
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var id = parseInt(child.dataset.id, 10);
      items.push({ id: id, position: i });
    }
    items.sort(function(a, b) {
      return a.id - b.id;
    });
    var positions = items.map(function(item) {
      return item.position;
    });
    this.onChange(positions);
  }

  update(configuration) {
    this.menu = configuration.menu;
    this.node = configuration.node;
    this.renderList();
  }

}

class ListItem {
  constructor() {
    this.el = el('div.list-item');
  }

  update(data) {
    this.el.textContent = data.content;
    this.el.dataset.position = data.position;
    this.el.dataset.id = data.id;
  }
}

export default ColumnsOrderPanel;